@if (showOrderingInformation) {
  <h2 class="help__heading">Ordering Support</h2>
  <p class="help__description">
    For further information about the ordering process, please see the help articles for
    <ftr-help-link cls="elevio__ordering-audio" label="ordering audio"></ftr-help-link> and
    <ftr-help-link cls="elevio__ordering-transcripts" label="ordering transcripts"></ftr-help-link>.
  </p>
  <p class="help__description">
    If you need help with amending and cancelling orders, status updates or required documentation, please contact the
    court directly.
  </p>
  @if (isLoggedIn) {
    <ftr-help-contact-details></ftr-help-contact-details>
  }
}
